import { Box, Stack } from '@mui/material';
import Button from '@/components/Button';
import SliderContent from '@/components/SliderContent';
import useResponsive from '@/hooks/useResponsive';
import Typography from '@/components/Typography';
import { ArrowLeft2 } from 'iconsax-react';
import Post from './Post';

const PostsSection = () => {
  const { matches } = useResponsive();
  const WrapperPosts = matches({ xs: SliderContent, lg: Stack });
  return (
    <Stack gap={{ xs: 1, lg: 2 }} mb={8}>
      <Typography
        textAlign={matches({ xs: 'center', lg: 'start' })}
        variant={matches({ xs: 'body1', lg: 'h6' })}
        weight="bold"
        component="p"
      >
        یادگیری ارز دیجیتال هیچ‌وقت انقدر آسون نبود!
      </Typography>
      <Typography
        textAlign={matches({ xs: 'center', lg: 'start' })}
        variant={matches({ xs: 'body3', lg: 'body2' })}
        mb={{ xs: 5, lg: 8.5 }}
      >
        مقاله‌های علمی، ویدیوهای آموزشی و اخبار روز ارز دیجیتال، یکجا تو آکادمی
        رابکس
      </Typography>
      <WrapperPosts
        {...matches({
          xs: {
            uniqueId: 'blog-posts',
            itemsProps: {
              sx: {
                width: '79.7%',
                '&:first-child': { marginLeft: 4 },
                '&:last-child': { marginRight: 4 }
              }
            }
          },
          lg: {
            gap: 2,
            flexDirection: 'row'
          }
        })}
      >
        <Box p={1}>
          <Post
            image="/assets/posts/academy3.png"
            title="بلاک چین چیست ؟"
            link="https://rabex.ir/academy/articles/what-is-blockchain/"
            description="بلاک چین مجموعه‌ای از بلاک‌های متصل به هم است. هر بلاک در بلاک چین شامل تعداد زیادی تراکنش است که توسط کاربرها تایید و به بلاک چین اضافه می‌شود."
          />
        </Box>
        <Box p={1}>
          <Post
            image="/assets/posts/academy2.png"
            title="ارز دیجیتال چیست ؟"
            link="https://rabex.ir/academy/articles/what-is-digital-currency/"
            description="ارز دیجیتال ارزی است که در بستر اینترنت قابل انتقال است. رمز ارزها دسته‌ای از ارزهای دیجیتال‌اند که از تکنولوژی بلاک چین و رمزنگاری استفاده می‌کنند."
          />
        </Box>
        <Box p={1}>
          <Post
            image="/assets/posts/academy1.png"
            title="آموزش ترید"
            link="https://rabex.ir/academy/articles/what-is-trade/"
            description="ترید به صورت عمومی به معنای خرید و فروش کالا و خدمات است اما در بازارهای مالی منظور از ترید خرید و فروش ابزارهای مالی مثل سهام و ارزهای دیجیتال است."
          />
        </Box>
      </WrapperPosts>
      <Stack alignSelf="center" mt={{ xs: 2, lg: 13.5 }}>
        <a href="https://rabex.ir/academy/" target="_blank">
          <Button
            size={matches({ xs: 'small', lg: 'medium' })}
            fullWidth={matches({ xs: true, lg: false })}
            color="primary"
            endIcon={<ArrowLeft2 size={24} />}
          >
            آکادمی رابکس
          </Button>
        </a>
      </Stack>
    </Stack>
  );
};

export default PostsSection;
